import React from 'react';
import { GenericErrorSvg } from './illustrations/generic-error-svg';

interface GenericErrorProps {
  message?: string;
}

export const GenericError: React.FC<GenericErrorProps> = ({ message }) => {
  return (
    <div className="text-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
      {/* Dynamic SVG Illustration */}
      <div className="flex justify-center my-2">
        <GenericErrorSvg />
      </div>

      {/* Heading & Subtitle */}
      <div className="space-y-3 max-w-lg mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Something went wrong...
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base leading-relaxed">
          {message || "The page you are looking for does not exist or an unexpected error occurred."}
        </p>
      </div>
    </div>
  );
};

export default GenericError;
